import {PromotionType} from "../../promotion/helpers/PromotionType";
import {IOfferBoxOffer} from "../types/IOfferBoxOffer";

export const hasOfferNoContributionPromotion = (offer: IOfferBoxOffer) =>
    "promotions" in offer && offer.promotions?.some((promotion) => promotion.type === PromotionType.NO_CONTRIBUTION);
